import { PictureColumn, PictureData } from '../../../../../shared/public-api';
import { BaseComponent } from '../../../../base/base.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-base-picture',
  templateUrl: './base-picture.component.html',
  styleUrls: ['./base-picture.component.scss'],
  standalone: true,
})
export class BasePictureComponent extends BaseComponent<PictureData> implements OnInit {
  pictureColumns: PictureColumn[];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.data.pictureColumns = this.data.pictureColumns.sort((a, b) => a.order - b.order);
    this.data.pictureColumns.forEach((c) => {
      c.pictures = c.pictures.sort((a, b) => a.order - b.order);
    });
    this.pictureColumns = this.data.pictureColumns;
  }
}
